import { createAuthClient } from 'better-auth/react';
import { polarClient } from '@polar-sh/better-auth';

// Create the auth client pointing to our backend
export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:4000',
  plugins: [polarClient()],
  fetchOptions: {
    credentials: 'include', // Required for cross-origin cookie support
  },
});

// Export hooks and utilities
export const {
  signIn,
  signOut,
  signUp,
  useSession,
  getSession,
} = authClient;

// GitHub OAuth sign-in helper
export const signInWithGitHub = () => {
  return signIn.social({
    provider: 'github',
    callbackURL: window.location.origin,
  });
};

// Export Polar-specific methods
export const checkout = authClient.checkout;
export const customer = authClient.customer;

// Email verification - resend verification email
export const sendVerificationEmail = authClient.sendVerificationEmail;

// Password reset functions
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

export async function forgetPassword(email: string) {
  const response = await fetch(`${API_URL}/api/auth/forgot-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ email }),
  });

  const data = await response.json();
  
  if (!response.ok) {
    return {
      error: {
        message: data.message || data.error || 'Failed to send password reset email',
      },
    };
  }

  return { data };
}

export async function resetPassword(token: string, password: string) {
  const response = await fetch(`${API_URL}/api/auth/reset-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ token, password }),
  });

  const data = await response.json();
  
  if (!response.ok) {
    return {
      error: {
        message: data.message || data.error || 'Failed to reset password',
      },
    };
  }

  return { data };
}

// Type exports
export type Session = typeof authClient.$Infer.Session;

